import React from 'react'

type DPGRLogoProps = {
  width?: number
  height?: number
  className?: string
  color?: string
}

const DPGRLogo: React.FunctionComponent<DPGRLogoProps> = ({
  width = 27,
  height = 24,
  className,
  color = '#3F3F3F',
}) => (
  <svg
    className={className}
    width={width}
    height={height}
    viewBox={`0 0 27 24`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.9304 0L19.5394 0.00191523L19.532 20.9489L14.923 20.947L14.9304 0ZM27 15.3643H22.3835V6.61987H27V15.3643ZM4.61637 20.9488H0V12.7968H4.61637V20.9488ZM7.46082 24.0001H12.0787V6.61987H7.46082V24.0001Z"
      fill={color}
    />
  </svg>
)

export default DPGRLogo
